import { useEffect } from 'react';
import { navigate } from "@reach/router"

const WaterWastewaterPage = () => {
  useEffect(() => {
    navigate('/solutions/industries/other-industries/');
  }, []);
  return null;
};

export default WaterWastewaterPage;